module.exports = __webpack_public_path__ + "static/media/南投縣政府新logo.16d29fbd.png";